import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';

const CONSENT_KEY = 'cookie_consent';
const ACCEPTED = 'accepted';
const REJECTED = 'rejected';

const CookieConsent: React.FC = () => {
  const [consentValue, setConsentValue] = useState<string | null>(null);

  useEffect(() => {
    const savedConsent = window.localStorage.getItem(CONSENT_KEY);
    setConsentValue(savedConsent);
  }, []);

  const handleAccept = () => {
    window.localStorage.setItem(CONSENT_KEY, ACCEPTED);
    setConsentValue(ACCEPTED);

    if (typeof (window as any).acceptAnalyticsCookies === 'function') {
      (window as any).acceptAnalyticsCookies();
      return;
    }

    window.dispatchEvent(new Event('cookie-consent-accepted'));
  };

  const handleReject = () => {
    window.localStorage.setItem(CONSENT_KEY, REJECTED);
    setConsentValue(REJECTED);

    if (typeof (window as any).rejectAnalyticsCookies === 'function') {
      (window as any).rejectAnalyticsCookies();
      return;
    }

    window.dispatchEvent(new Event('cookie-consent-rejected'));
  };

  if (consentValue === ACCEPTED || consentValue === REJECTED) {
    return null;
  }

  return (
    <Paper
      elevation={10}
      sx={{
        backgroundColor: '#132039',
        borderRadius: 0,
        bottom: 0,
        color: '#ffffff',
        left: 0,
        padding: { sm: '18px 24px', xs: '16px' },
        position: 'fixed',
        right: 0,
        zIndex: 1700,
      }}>
      <Stack
        alignItems={{ sm: 'center' }}
        direction={{ sm: 'row', xs: 'column' }}
        justifyContent="space-between"
        spacing={2}>
        <Typography
          sx={{
            color: '#fff',
            fontFamily: 'FiraSans-Regular',
            fontSize: '0.95rem',
          }}>
          We use analytics cookies to improve your experience. You can accept or
          reject these cookies.
        </Typography>

        <Stack direction="row" spacing={1.5}>
          <Button
            onClick={handleReject}
            sx={{
              borderColor: '#8c95aa',
              color: '#ffffff',
              fontFamily: 'FiraSans-SemiBold',
              minWidth: 128,
            }}
            variant="outlined">
            Reject
          </Button>
          <Button
            onClick={handleAccept}
            sx={{
              '&:hover': {
                backgroundColor: '#e6ce56',
              },
              backgroundColor: '#dec330',
              color: '#0f1a2f',
              fontFamily: 'FiraSans-SemiBold',
              minWidth: 128,
            }}
            variant="contained">
            Accept
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default CookieConsent;
